import { render, staticRenderFns } from "./BaseSelectBox.vue?vue&type=template&id=8b591e5c&scoped=true&"
import script from "./BaseSelectBox.vue?vue&type=script&lang=js&"
export * from "./BaseSelectBox.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelectBox.vue?vue&type=style&index=0&id=8b591e5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b591e5c",
  null
  
)

export default component.exports